import { SET_APP_MESSAGE, CLEAR_APP_MESSAGE } from "./appMessageTypes";

/**
 * Publish a transient app-level notification (SCRUM-882/883). Use this — not the
 * errors slice — when a thunk needs to signal a success/info to the user: the
 * global notification hub (`GlobalNotifications`, SCRUM-883) reads
 * `state.appMessage`, toasts it, and clears it. Keeps `state.errors` a pure
 * error channel.
 *
 * Pass the final, ready-to-show text — no sentinel string the container has to
 * translate back into a message.
 *
 * @param {"success" | "info"} type
 * @param {string} message
 */
export const setAppMessage = (type, message) => (dispatch) => {
  dispatch({ type: SET_APP_MESSAGE, payload: { type, message } });
};

export const clearAppMessage = () => (dispatch) => {
  dispatch({ type: CLEAR_APP_MESSAGE });
};
